import { useEffect, useState } from "react";
import { mediaUrl } from "@/lib/api";

const diff = (target) => {
  const ms = Math.max(0, new Date(target).getTime() - Date.now());
  return { days: Math.floor(ms / 864e5), hours: Math.floor(ms / 36e5) % 24, minutes: Math.floor(ms / 6e4) % 60, seconds: Math.floor(ms / 1e3) % 60 };
};

export const Countdown = ({ target }) => {
  const [t, setT] = useState(diff(target));
  useEffect(() => {
    const i = setInterval(() => setT(diff(target)), 1000);
    return () => clearInterval(i);
  }, [target]);
  return (
    <div className="grid grid-cols-4 gap-2 sm:gap-4" data-testid="countdown">
      {Object.entries(t).map(([k, v]) => (
        <div key={k} className="rounded-2xl border border-white/20 bg-white/[.06] px-1 py-4 text-center backdrop-blur-md" data-testid={`countdown-${k}`}>
          <div className="font-serif-d text-3xl tabular-nums sm:text-5xl">{String(v).padStart(2, "0")}</div>
          <div className="mt-1 text-[10px] uppercase tracking-[.2em] opacity-80 sm:text-xs">{k}</div>
        </div>
      ))}
    </div>
  );
};

export const Carousel = ({ images = [] }) => {
  const [i, setI] = useState(0);
  useEffect(() => {
    if (images.length < 2) { return undefined; }
    const t = setInterval(() => setI((x) => (x + 1) % images.length), 5000);
    return () => clearInterval(t);
  }, [images.length]);
  if (!images.length) return null;
  return (
    <div className="relative aspect-[4/5] overflow-hidden rounded-[22px] sm:aspect-[16/10]" data-testid="home-carousel">
      {images.map((u, idx) => (
        <img key={`${u}-${idx}`} src={mediaUrl(u)} alt="" className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-[1200ms] ${idx === i ? "opacity-100" : "opacity-0"}`} />
      ))}
      <div className="absolute bottom-5 right-5 flex gap-2">
        {images.map((_, idx) => (
          <button key={`dot-${images[idx]}-${idx}`} onClick={() => setI(idx)} aria-label={`Photo ${idx + 1}`} data-testid={`carousel-dot-${idx}`}
            className={`h-1 rounded-full transition-all duration-500 ${idx === i ? "w-8 bg-white" : "w-4 bg-white/50"}`} />
        ))}
      </div>
    </div>
  );
};

export const Hero = ({ s, familyName }) => (
  <div className="grain relative overflow-hidden rounded-[26px] bg-[var(--wine)] px-6 py-12 text-center text-[var(--ivory)] sm:px-12 sm:py-16" data-testid="home-hero">
    <img src="/media/monogram.png" alt="" className="pointer-events-none absolute left-1/2 top-1/2 h-[120%] -translate-x-1/2 -translate-y-1/2 opacity-[.08]" />
    <div className="relative">
      <div className="rise text-xs uppercase tracking-[.3em] text-[var(--gold)]" data-testid="hero-greeting">Dear {familyName}</div>
      <div className="rise rise-1 mt-5 text-[11px] uppercase tracking-[.3em] opacity-80">{s.together_line}</div>
      <h1 className="rise rise-2 font-script mt-4 text-6xl leading-[1.05] sm:text-7xl lg:text-8xl" data-testid="hero-couple-names">
        {s.couple_first}
        <span className="my-1 block text-4xl text-[var(--gold)] sm:text-5xl">&amp;</span>
        {s.couple_second}
      </h1>
      <div className="rise rise-3 mt-6 text-xs uppercase tracking-[.3em] text-[var(--gold)] sm:text-sm">{s.date_text} · {s.location}</div>
      <div className="rise rise-4 mx-auto mt-8 max-w-lg"><Countdown target={s.countdown_target} /></div>
      <div className="mt-5 text-[11px] uppercase tracking-[.3em] opacity-80" data-testid="countdown-caption">{s.countdown_caption}</div>
    </div>
  </div>
);
